import AirTag from '@fly/air-tag';
import { install as installPlugins, getTrackerData } from '@fly/air-tag/vue';

// 默认规则配置文件路径
const defaultRulesUrl =
  process.env.NODE_ENV === 'production'
    ? `https://static-ayh-gtm.msxf.com/market/ejsData/air-tag/track-point/flow-${process.env.APP_NAME}/ets.json`
    : `https://static-ctest1.msxf.com/static/air-tag/track-online-point/flow-${process.env.APP_NAME}/ets.json`;

export default {
  install(
    Vue,
    {
      enable = true,
      runtime = false,
      reportTrack = (e, data) => window.REPORT_TRACK(e, data),
      baseData = {},
      globalBeforeTrackAsync,
      rulesUrl = defaultRulesUrl,
      subscriptions = {},
    },
  ) {
    if (enable) {
      const instance = new AirTag({
        element_mark: 'elementE_id',
        getUniqueId: function (el) {
          try {
            if (el.dataset && !el.attributes) {
              // fakeDOM
              const {
                elementE_id = '',
                elementM_id = '',
                elementS_id = '',
                elementT_id = '',
                elementP_id = '',
              } = el?.dataset || {};
              if (elementE_id && elementP_id) {
                return `${elementP_id}..${elementM_id}..${elementT_id}..${elementS_id}..${elementE_id}`;
              }
              return null;
            } else {
              const { p_id, t_id, m_id, s_id, e_id } = getTrackerData(el);
              if (p_id && e_id) {
                return `${p_id}..${m_id}..${t_id}..${s_id}..${e_id}`;
              }
              return null;
            }
          } catch (e) {
            return null;
          }
        },
        report_track: reportTrack,
        autoPageView: false,
        customExposureConfig: true,
        autoAccuratePv: true,
        base_data: baseData, // 全局私有基础数据
        global_before_track_async: globalBeforeTrackAsync, // 异步接口【获取异步全局私有基础：如会员类型】
        config: {
          rules_url: rulesUrl, // `http://static.msxf.test/static/air-tag/vip/project1/v1/rules.json`,
          exposure_config: {
            area_rate: 0.5,
            stay_duration: 0,
            repeated: false,
          },
        },
        subscriptions,
      });
      installPlugins(Vue, {
        runtime,
        instance,
      });
    }
  },
};
